import { Component, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-help-pension',
  templateUrl: './modal-help-pension.component.html',
  styleUrls: ['./modal-help-pension.component.scss']
})
export class ModalHelpPensionComponent implements OnInit {

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ModalHelpPensionComponent>
  ) { }

  ngOnInit() {
  }

  closeModal(): void {
    this.dialogRef.close();
  }

}
